
import { FIREARM_METADATA } from '../../firearm/model/firearm.metadata';
import { FIREARM_STORAGE_LOCATION_METADATA } from '../../firearm_storage_location/model/firearm-storage-location.metadata';
import { RANGER_METADATA } from '../../ranger/model/ranger.metadata';
import { TRANSFER_ASSET_METADATA } from '../../transferasset/model/transfer-asset.metadata';
import { ASSETS_USER_DETAILS_METADATA } from '../../userdetails/model/assets-user-details.metadata';
import { FirearmAssignmentLifecycleState, FirearmAssignmentNextAction, FirearmAssignmentStorageType, FirearmAssignmentType } from './firearm-assignment.types';
import { EntityMetadata, GenericEntityMetadata, PropertyMetadata, RelationshipType, TemporalType, nullIfContainsNull } from '@scisys-uim/uim-common';


export class FirearmAssignmentMetadataBase extends GenericEntityMetadata {
  constructor() {
    super('FirearmAssignment', {
      firearmAssignmentId: <PropertyMetadata> {
        name: 'firearmAssignmentId',
        type: 'number',
        plural: false,
        isIdentity: true,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        unique: false
      },
      firearm: <PropertyMetadata> {
        name: 'firearm',
        type: 'Firearm',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        relationship: true,
        relationshipType: RelationshipType.ManyToOne,
        get relationshipEntityMetadata(): EntityMetadata {
          return FIREARM_METADATA;
        },
        byReference: true,
        unique: false
      },
      gunDealerLocation: <PropertyMetadata> {
        name: 'gunDealerLocation',
        type: 'FirearmStorageLocation',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        relationship: true,
        relationshipType: RelationshipType.ManyToOne,
        get relationshipEntityMetadata(): EntityMetadata {
          return FIREARM_STORAGE_LOCATION_METADATA;
        },
        byReference: true,
        unique: false
      },
      location: <PropertyMetadata> {
        name: 'location',
        type: 'FirearmStorageLocation',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        relationship: true,
        relationshipType: RelationshipType.ManyToOne,
        get relationshipEntityMetadata(): EntityMetadata {
          return FIREARM_STORAGE_LOCATION_METADATA;
        },
        byReference: true,
        unique: false
      },
      ranger: <PropertyMetadata> {
        name: 'ranger',
        type: 'Ranger',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        relationship: true,
        relationshipType: RelationshipType.ManyToOne,
        get relationshipEntityMetadata(): EntityMetadata {
          return RANGER_METADATA;
        },
        byReference: true,
        unique: false
      },
      transferAsset: <PropertyMetadata> {
        name: 'transferAsset',
        type: 'TransferAsset',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        relationship: true,
        relationshipType: RelationshipType.ManyToOne,
        get relationshipEntityMetadata(): EntityMetadata {
          return TRANSFER_ASSET_METADATA;
        },
        byReference: true,
        unique: false
      },
      user: <PropertyMetadata> {
        name: 'user',
        type: 'AssetsUserDetails',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        relationship: true,
        relationshipType: RelationshipType.ManyToOne,
        get relationshipEntityMetadata(): EntityMetadata {
          return ASSETS_USER_DETAILS_METADATA;
        },
        byReference: true,
        unique: false
      },
      actionPending: <PropertyMetadata> {
        name: 'actionPending',
        type: 'boolean',
        plural: false,
        isIdentity: false,
        derived: true,
        required: false,
        readOnly: true,
        readable: true,
        writeable: false,
        unique: false
      },
      activatedBy: <PropertyMetadata> {
        name: 'activatedBy',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 255,
        unique: false
      },
      activatedDate: <PropertyMetadata> {
        name: 'activatedDate',
        type: 'Date',
        temporalType: TemporalType.TIMESTAMP,
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        unique: false
      },
      buApprovalRejectionReason: <PropertyMetadata> {
        name: 'buApprovalRejectionReason',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 1000,
        unique: false
      },
      buApproved: <PropertyMetadata> {
        name: 'buApproved',
        type: 'boolean',
        plural: false,
        isIdentity: false,
        derived: false,
        required: true,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 1,
        unique: false
      },
      buApprovedRejectedBy: <PropertyMetadata> {
        name: 'buApprovedRejectedBy',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 255,
        unique: false
      },
      buApprovedRejectedDate: <PropertyMetadata> {
        name: 'buApprovedRejectedDate',
        type: 'Date',
        temporalType: TemporalType.TIMESTAMP,
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        unique: false
      },
      canceledBy: <PropertyMetadata> {
        name: 'canceledBy',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 255,
        unique: false
      },
      canceledDate: <PropertyMetadata> {
        name: 'canceledDate',
        type: 'Date',
        temporalType: TemporalType.TIMESTAMP,
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        unique: false
      },
      canceledReason: <PropertyMetadata> {
        name: 'canceledReason',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 1000,
        unique: false
      },
      comments: <PropertyMetadata> {
        name: 'comments',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 1000,
        unique: false
      },
      createdBy: <PropertyMetadata> {
        name: 'createdBy',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 255,
        unique: false
      },
      createdDate: <PropertyMetadata> {
        name: 'createdDate',
        type: 'Date',
        temporalType: TemporalType.TIMESTAMP,
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        unique: false
      },
      currentAssignment: <PropertyMetadata> {
        name: 'currentAssignment',
        type: 'boolean',
        plural: false,
        isIdentity: false,
        derived: true,
        required: false,
        readOnly: true,
        readable: true,
        writeable: false,
        unique: false
      },
      endDate: <PropertyMetadata> {
        name: 'endDate',
        type: 'Date',
        temporalType: TemporalType.TIMESTAMP,
        plural: false,
        isIdentity: false,
        derived: true,
        required: false,
        readOnly: true,
        readable: true,
        writeable: false,
        unique: false
      },
      firearmAssignmentType: <PropertyMetadata> {
        name: 'firearmAssignmentType',
        type: 'FirearmAssignmentType',
        plural: false,
        isIdentity: false,
        derived: false,
        required: true,
        readOnly: false,
        readable: true,
        writeable: true,
        unique: false
      },
      gunDealerLocationId: <PropertyMetadata> {
        name: 'gunDealerLocationId',
        type: 'number',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        unique: false
      },
      handoverAcknowledgedBy: <PropertyMetadata> {
        name: 'handoverAcknowledgedBy',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 255,
        unique: false
      },
      handoverAcknowledgedDate: <PropertyMetadata> {
        name: 'handoverAcknowledgedDate',
        type: 'Date',
        temporalType: TemporalType.TIMESTAMP,
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        unique: false
      },
      lastStateChangeDate: <PropertyMetadata> {
        name: 'lastStateChangeDate',
        type: 'Date',
        temporalType: TemporalType.TIMESTAMP,
        plural: false,
        isIdentity: false,
        derived: true,
        required: false,
        readOnly: true,
        readable: true,
        writeable: false,
        unique: false
      },
      leadApprovalRejectionReason: <PropertyMetadata> {
        name: 'leadApprovalRejectionReason',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 1000,
        unique: false
      },
      leadApproved: <PropertyMetadata> {
        name: 'leadApproved',
        type: 'boolean',
        plural: false,
        isIdentity: false,
        derived: false,
        required: true,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 1,
        unique: false
      },
      leadApprovedRejectedBy: <PropertyMetadata> {
        name: 'leadApprovedRejectedBy',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 255,
        unique: false
      },
      leadApprovedRejectedDate: <PropertyMetadata> {
        name: 'leadApprovedRejectedDate',
        type: 'Date',
        temporalType: TemporalType.TIMESTAMP,
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        unique: false
      },
      lifecycleState: <PropertyMetadata> {
        name: 'lifecycleState',
        type: 'FirearmAssignmentLifecycleState',
        plural: false,
        isIdentity: false,
        derived: true,
        required: false,
        readOnly: true,
        readable: true,
        writeable: false,
        unique: false
      },
      locationId: <PropertyMetadata> {
        name: 'locationId',
        type: 'number',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        unique: false
      },
      lockVersion: <PropertyMetadata> {
        name: 'lockVersion',
        type: 'number',
        plural: false,
        isIdentity: false,
        derived: true,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        unique: false
      },
      nextAction: <PropertyMetadata> {
        name: 'nextAction',
        type: 'FirearmAssignmentNextAction',
        plural: false,
        isIdentity: false,
        derived: true,
        required: false,
        readOnly: true,
        readable: true,
        writeable: false,
        unique: false
      },
      notifyPolice: <PropertyMetadata> {
        name: 'notifyPolice',
        type: 'boolean',
        plural: false,
        isIdentity: false,
        derived: false,
        required: true,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 1,
        unique: false
      },
      personEmail: <PropertyMetadata> {
        name: 'personEmail',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: false,
        required: true,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 255,
        unique: false
      },
      personalFirearmAssignment: <PropertyMetadata> {
        name: 'personalFirearmAssignment',
        type: 'boolean',
        plural: false,
        isIdentity: false,
        derived: false,
        required: true,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 1,
        unique: false
      },
      policeNotificationEligible: <PropertyMetadata> {
        name: 'policeNotificationEligible',
        type: 'boolean',
        plural: false,
        isIdentity: false,
        derived: true,
        required: false,
        readOnly: true,
        readable: true,
        writeable: false,
        unique: false
      },
      policeNotificationReason: <PropertyMetadata> {
        name: 'policeNotificationReason',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 2000,
        unique: false
      },
      policeNotifiedDate: <PropertyMetadata> {
        name: 'policeNotifiedDate',
        type: 'Date',
        temporalType: TemporalType.TIMESTAMP,
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        unique: false
      },
      previousStartedFirearmAssignmentId: <PropertyMetadata> {
        name: 'previousStartedFirearmAssignmentId',
        type: 'number',
        plural: false,
        isIdentity: false,
        derived: true,
        required: false,
        readOnly: true,
        readable: true,
        writeable: false,
        unique: false
      },
      sortDate: <PropertyMetadata> {
        name: 'sortDate',
        type: 'Date',
        temporalType: TemporalType.TIMESTAMP,
        plural: false,
        isIdentity: false,
        derived: true,
        required: false,
        readOnly: true,
        readable: true,
        writeable: false,
        unique: false
      },
      startDate: <PropertyMetadata> {
        name: 'startDate',
        type: 'Date',
        temporalType: TemporalType.TIMESTAMP,
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        unique: false
      },
      startedBy: <PropertyMetadata> {
        name: 'startedBy',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 255,
        unique: false
      },
      storageType: <PropertyMetadata> {
        name: 'storageType',
        type: 'FirearmAssignmentStorageType',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        unique: false
      },
      updatedBy: <PropertyMetadata> {
        name: 'updatedBy',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 255,
        unique: false
      },
      updatedDate: <PropertyMetadata> {
        name: 'updatedDate',
        type: 'Date',
        temporalType: TemporalType.TIMESTAMP,
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        unique: false
      },
      withExpiredStartToken: <PropertyMetadata> {
        name: 'withExpiredStartToken',
        type: 'boolean',
        plural: false,
        isIdentity: false,
        derived: true,
        required: false,
        readOnly: true,
        readable: true,
        writeable: false,
        unique: false
      },
      withStartToken: <PropertyMetadata> {
        name: 'withStartToken',
        type: 'boolean',
        plural: false,
        isIdentity: false,
        derived: true,
        required: false,
        readOnly: true,
        readable: true,
        writeable: false,
        unique: false
      }
    });
  }
  toKeyObject(item: any): any {
    const result = item?.firearmAssignmentId;
    return nullIfContainsNull(result);
  }
}



